import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  Link,
  OutlinedInput,
  Typography
} from '@mui/material';

import {
  fieldLabelSx,
  forgotLinkSx,
  formControlSx,
  formWrapperSx,
  requiredSx,
  signInButtonSx,
  signInSubtitleSx,
  signInTitleSx
} from '../../Common/components/Styles/AuthStyles';

const ForgotUsernameForm = ({
  formState,
  hasError,
  onBack,
  onChange,
  onSubmit
}) => {
  const emailId = React.useId();

  const errorMessage = formState.errors.email?.[0] || '';

  return (
    <Box component="form" noValidate onSubmit={onSubmit} sx={{...formWrapperSx,gap:1}}>
      <Box>
        <Typography component="h2" sx={signInTitleSx}>
          Forgot Username
        </Typography>

        <Typography sx={signInSubtitleSx}>
          Enter the email address associated with your account.
        </Typography>
      </Box>

      <Box>
        <Typography component="label" htmlFor={emailId} sx={fieldLabelSx}>
          Email
          <Box component="span" sx={requiredSx}>
            *
          </Box>
        </Typography>

        <FormControl
          error={hasError('email')}
          fullWidth
          sx={formControlSx}
          variant="outlined">
          <OutlinedInput
            autoComplete="email"
            id={emailId}
            name="email"
            onChange={onChange}
            placeholder="Enter your email address"
            type="email"
            value={formState.values.email}
          />

          <FormHelperText
            sx={{
              minHeight: 16,
              visibility: hasError('email') ? 'visible' : 'hidden'
            }}>
            {errorMessage}
          </FormHelperText>
        </FormControl>
      </Box>

      <Button
        disabled={!formState.isValid}
        fullWidth
        sx={{
          ...signInButtonSx,
          mt: 2
        }}
        type="submit"
        variant="contained">
        Request Username
      </Button>

      <Typography
        sx={{
          color: '#8C8C8C',
          fontSize: 13,
          fontStyle: 'italic',
          mt: 2,
          textAlign: 'center'
        }}>
        Remember your username?{' '}
        <Link
          component="button"
          onClick={onBack}
          sx={{
            ...forgotLinkSx,
            background: 'none',
            border: 0,
            cursor: 'pointer',
            fontStyle: 'normal',
            fontWeight: 600,
            px: 0.5
          }}
          type="button">
          Sign In
        </Link>
      </Typography>
    </Box>
  );
};

ForgotUsernameForm.propTypes = {
  formState: PropTypes.shape({
    errors: PropTypes.object.isRequired,
    isValid: PropTypes.bool.isRequired,
    values: PropTypes.shape({
      email: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
  hasError: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

export default ForgotUsernameForm;
